<!--
  线下活动任务规则弹窗
  这个弹窗没有表格，白卡里就是一段说明文字
-->
<script lang="ts">
  import { _ as t } from "svelte-i18n";
  import BottomSheet from "./BottomSheet.svelte";
  import balloon from "../assets/images/dialog/balloon.png";
  import actIcon from "../assets/images/dialog/icon-act.png";
  import underline from "../assets/images/dialog/deco-underline.png";
  import star from "../assets/images/dialog/deco-star.png";

  interface Props {
    show: boolean;
    onClose: () => void;
  }

  let { show, onClose }: Props = $props();
</script>

<BottomSheet {show} {onClose}>
  <!-- 气球：压在弹窗左上角并向上溢出 -->
  <img src={balloon} alt="" class="dlg-balloon" />

  <!-- 标题：线下活动（金色）+ 任务规则（白色） -->
  <div class="dlg-title-wrap">
    <h2 class="dlg-title">
      <span class="dlg-title-hl">{$t("offline_rule_title_hl")}</span
      >{$t("offline_rule_title")}
    </h2>
    <img src={underline} alt="" class="dlg-title-line" />
    <img src={star} alt="" class="dlg-title-star is-right" />
    <img src={star} alt="" class="dlg-title-star is-left" />
  </div>

  <!-- 白色内容卡：无表格，只有一段说明 -->
  <div class="dlg-card">
    <img src={actIcon} alt="" class="dlg-act-icon" />

    <p class="dlg-card-title">{$t("guide_title")}</p>
    <p class="dlg-note">{$t("offline_note")}</p>
  </div>

  <button type="button" class="grad-btn dlg-confirm" onclick={onClose}>
    {$t("btn_confirm")}
  </button>
</BottomSheet>

<style>
  /* 气球 152x258@2x = 76x129，向上溢出弹窗顶边 */
  .dlg-balloon {
    position: absolute;
    top: -26px;
    left: -4px;
    width: 76px;
    height: 129px;
  }

  /* 顶部间距由弹窗的 padding-top 26px 提供，这里只留标题到白卡的距离 */
  .dlg-title-wrap {
    position: relative;
    padding-bottom: 6px;
    text-align: center;
  }

  /* 标题（设计稿）：20px / 700 / line-height 20px / shadow 0 2px 2px #165BFD */
  .dlg-title {
    position: relative;
    z-index: 1;
    font-size: 20px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0;
    color: #ffffff;
    text-shadow: 0 2px 2px #165bfd;
  }

  /* 高亮部分「线下活动」：#FFDF00 */
  .dlg-title-hl {
    color: #ffdf00;
  }

  /* 标题笔画 149x18@2x = 74.5x9，压在标题右下方 */
  .dlg-title-line {
    position: absolute;
    bottom: -3px;
    left: 50%;
    width: 74.5px;
    height: 9px;
    margin-left: 5px;
  }

  /* 小星星 16x16@2x = 8x8 */
  .dlg-title-star {
    position: absolute;
    left: 50%;
    width: 8px;
    height: 8px;
  }

  .dlg-title-star.is-right {
    top: -2px;
    margin-left: 82px;
    transform: rotate(-20deg);
  }

  .dlg-title-star.is-left {
    top: 21px;
    margin-left: -91px;
    transform: rotate(15deg);
  }

  .dlg-card {
    position: relative;
    margin-top: 15px;
    padding: 12px;
    border-radius: 16px;
    background: #ffffff;
  }

  /* 活动图标 180x132，按同比例渲染 82x60，压在白卡右上角 */
  .dlg-act-icon {
    position: absolute;
    top: -20px;
    right: 8px;
    width: 82px;
    height: 60px;
  }

  /* 获取攻略（设计稿）：16px / 600 / line-height 24px / #003EC7 */
  .dlg-card-title {
    position: relative;
    z-index: 1;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0;
    color: #003ec7;
  }

  /* 说明文字（设计稿）：14px / 400 / line-height 150% / #001746 */
  .dlg-note {
    margin-top: 12px;
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0;
    color: #001746;
    text-align: justify;
    text-justify: inter-ideograph;
  }

  /* 渐变底 + 1.5px 渐变描边 + 内阴影同任务按钮，见 app.css 的 .grad-btn */
  .dlg-confirm {
    width: 100%;
    height: 48px;
    margin-top: 24px;
    border-radius: 24px;
    font-size: 16px;
    font-weight: 600;
    line-height: 1;
  }
</style>
